import React, { useMemo, } from 'react';
import { useIntl } from 'umi';
import { Col, Row } from 'tea-component';
import OpinionsCard from '../OpinionsCard';
import { changeChannel, getDefaultChannelList } from '@op/pages/community/constants';
import useStreamingTrendsData from './useStreamingTrendsData';
import OpinionsStreamingChart from './OpinionsStreamingChart';
import { echartCountMat } from '@op/utils';
import { LANGUAGE_EN } from '@home/_config/config';
import './index.scss';
function OpinionsStreaming(props: any) {
  const { gameInfo, filter, extraParams, formatRule = 'intBmk00', id, refArray, index, style } = props;

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  const params = useMemo(() => {
    if (!filter?.date_type || !gameInfo?.edition_unified_id) return {};
    const channelList = getDefaultChannelList(gameInfo.edition_unified_id);
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    return { ...(restFilter || {}), ...extraParams, channel_type: "social", channels: changeChannel(channelList) };
  }, [filter, gameInfo.edition_unified_id, extraParams]);

  const {
    // loading: hoursWatchedLoading,
    total: hoursWatchedTotal,
  } = useStreamingTrendsData({ gameInfo, params, metric: "hoursWatched" });

  const {
    loading: peakCCVLoading,
    total: peakCCVTotal,
    lineSeriesData: peakCCVLineSeriesData,
    lineXAxisData: peakCCVLineXAxisData
  } = useStreamingTrendsData({ gameInfo, params, metric: "peakCCV" });

  const {
    loading: avgCCVLoading,
    total: avgCCVTotal,
    lineSeriesData: avgCCVLineSeriesData,
    lineXAxisData: avgCCVLineXAxisData
  } = useStreamingTrendsData({ gameInfo, params, metric: "avgCCV" });

  const cardList = useMemo(() => [
    { title: isEn ? "Hours Watched" : "观看时长", value: hoursWatchedTotal, formatRule, span: 8 },
    { title: isEn ? "Peak CCV" : " 直播观众峰值", value: peakCCVTotal, formatRule, span: 8 },
    { title: isEn ? "Avg CCV" : "直播观众平均值", value: avgCCVTotal, formatRule, span: 8 },
  ], [avgCCVTotal, formatRule, hoursWatchedTotal, isEn, peakCCVTotal]);

  const { peakCCVTitle, avgCCVTitle } = useMemo(() => ({
    peakCCVTitle: isEn ? "Peak Viewers" : "峰值观看人数",
    avgCCVTitle: isEn ? "Avg. Viewers" : "平均观看人数",
  }), [isEn]);

  return (
    <div className='dbh-opinions-Streaming' id={id} data-scroll-index={index} ref={refArray?.[index]} style={style} >
      <Row>
        {
          cardList?.map((item: any) => {
            const { title, value, formatRule, span } = item || {};
            return <Col span={span} key={title}>
              <OpinionsCard
                title={title}
                value={value}
                dataValue={echartCountMat(value)}
                formatRule={formatRule}
              />
            </Col>;
          })
        }
      </Row>
      <Row>
        <Col span={12}>
          <OpinionsStreamingChart
            metric={"peakCCV"}
            params={params}
            gameInfo={gameInfo}
            title={<div className='trends-card-title'>{peakCCVTitle}</div>}
            metricsOptions={[{ text: peakCCVTitle, value: 'peakCCV' }]}
            total={peakCCVTotal}
            loading={peakCCVLoading}
            lineSeriesData={peakCCVLineSeriesData}
            lineXAxisData={peakCCVLineXAxisData}
          />
        </Col>
        <Col span={12}>
          <OpinionsStreamingChart
            metric={"avgCCV"}
            params={params}
            gameInfo={gameInfo}
            title={<div className='trends-card-title'>{avgCCVTitle}</div>}
            metricsOptions={[{ text: avgCCVTitle, value: 'avgCCV' }]}
            total={avgCCVTotal}
            loading={avgCCVLoading}
            lineSeriesData={avgCCVLineSeriesData}
            lineXAxisData={avgCCVLineXAxisData}
          />
        </Col>
      </Row>
    </div>
  );
}

export default OpinionsStreaming;
